import { readable } from 'svelte/store';
export const tz_name = readable(get_tz_name(), function start(set) {
  // updates timezone name every minute
  const interval = setInterval(() => {
    set(get_tz_name());
  }, 1000 * 60);

  return function stop() {
    clearInterval(interval);
  }
});

function get_tz_name() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
